<div class="card step mr-auto ml-auto">
   <div class="card-header step-header" id="finalStep">
      <div class="col-12">
         <div class="d-flex flex-row align-content-center col-12">
            <span class="d-flex align-items-center">
               <span
                  ><b class="step-text">3. {{ translatePath + 'order-review' | translate }}</b></span
               >
            </span>
         </div>
      </div>
   </div>
   <div #finalStepId="ngbCollapse" [(ngbCollapse)]="!expanded">
      <div class="card-body d-flex flex-column">
         <div class="col-12">
            <div class="d-flex flex-column col-12">
               <div class="align-self-center">
                  <input class="form-check-input" type="checkbox" id="termsCheck" [(ngModel)]="termsCheck" />
                  <label class="form-check-label" for="termsCheck">
                     <span class="terms pl-1">
                        {{ 'public.termsAndConditions.0' | translate }}
                        <a class="pl-1" routerLink="../terms-and-conditions" target="new">{{
                           'public.termsAndConditions.1' | translate
                        }}</a>
                        {{ 'public.termsAndConditions.2' | translate }}
                     </span>
                  </label>
               </div>
               <small class="text-danger ml-xl-4 ml-0 pl-2" *ngIf="termsCheck == false">{{
                  'validation-errors.term-message' | translate
               }}</small>
            </div>
         </div>

         <div class="col-12">
            <div class="d-flex flex-column col-12">
               <div class="align-self-center">
                  <input
                     class="form-check-input"
                     type="checkbox"
                     id="carrierTermsCheck"
                     [(ngModel)]="carrierTermsCheck"
                  />
                  <label class="form-check-label" for="carrierTermsCheck">
                     <span class="terms pl-1">
                        {{ 'public.termsAndConditions.0' | translate }}
                        <a class="pl-1" href="{{ option?.carrier?.termsAndConditions }}" target="new"
                           >{{ option?.carrier?.carrierName }} {{ 'public.termsAndConditions.1' | translate }}</a
                        >
                        {{ 'public.termsAndConditions.2' | translate }}
                     </span>
                  </label>
               </div>
               <small class="text-danger ml-xl-4 ml-0 pl-2" *ngIf="carrierTermsCheck == false">{{
                  'validation-errors.term-message' | translate
               }}</small>
            </div>
         </div>

         <div>
            <div class="col-12">
               <div class="btns col-12 d-flex flex-row-reverse">
                  <button
                     [disabled]="loading || (!termsCheck && !carrierTermsCheck)"
                     (click)="pay()"
                     type="button"
                     class="h-auto btn btn-primary btn-sm text-capitalize"
                  >
                     <span>
                        {{ 'buttons.pay-order' | translate }}
                     </span>
                  </button>

                  <button *ngIf="returUrl" type="button" class="btn btn-outline-info mr-5" (click)="cancel()">
                     <span>
                        {{ 'buttons.cancel' | translate }}
                     </span>
                  </button>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
